<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.name"
        :disabled="typeof breadcrumb.link === 'undefined'"
        :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <h1 class="text-xs-left my-3 ml-3">Активность агентов</h1>
    <v-layout row class="ml-3">
      <v-flex xs12 v-if="$store.getters.user !== null">
        <v-layout row v-if="$store.getters.user.sale_group === null">
          <v-flex xs4 lg4 md4>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              v-model="menu"
              :nudge-right="40"
              :return-value.sync="date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              class="mr-3"
              style="z-index: 1001;"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Дата"
                readonly
                outline
              ></v-text-field>
              <v-date-picker
                v-model="date"
                @input="inputDate"
                locale="ru"
                :first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs4 lg4 md4 v-if="$store.getters.user.branch === null">
            <v-select
              :items="branchTitleList"
              label="Филиал"
              v-model="branch"
              class="mr-3"
              @input="onBranchSelect()"
              outline
              no-data-text="Нет данных"
              style="z-index: 1001;"
            ></v-select>
          </v-flex>

          <v-flex xs4 lg4 md4 v-if="branch !== 'Все филиалы' && branch !== null">
            <v-select
              :items="saleGroupTitleList"
              label="Супервайзер"
              v-model="saleGroup"
              class="mr-3"
              @input="onSaleGroupSelect()"
              outline
              no-data-text="Нет данных"
              style="z-index: 1001;"
            ></v-select>
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12>
        <div id="leaflet-map" style="width: 100%; height: 700px;"></div>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import L from 'leaflet'
  import 'leaflet/dist/leaflet.css'

  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Активность агентов'}
        ],
        pageDataReady: {
          isReady: false,
          branchList: false
        },
        date: null,
        dateFormatted: null,
        menu: false,
        branch: null,
        branchId: null,
        saleGroup: null,
        saleGroupId: null,
        agents: [],
        map: null,
        timeout: null,
        layers: []
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.branchList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
          this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
        } else {
          this.branchId = null
        }
        this.updateUrl()
      },
      onSaleGroupSelect () {
        if (this.saleGroup !== null && this.saleGroup !== 'Все супервайзеры') {
          for (let i = 0; i < this.saleGroupList.length; i++) {
            if (this.saleGroupList[i].title === this.saleGroup) {
              this.saleGroupId = this.saleGroupList[i].id
              break
            }
          }
        } else {
          this.saleGroupId = null
        }
        this.updateUrl()
      },
      inputDate () {
        this.$refs.menu.save(this.date)
        this.updateUrl()
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      getAgentList () {
        if (this.date !== null) {
          let data = {
            date: this.date + ' 00:00:00',
            branchId: this.branchId,
            saleGroupId: this.saleGroupId,
            limit: 1000
          }

          this.$store.dispatch('getAgentList', data)
        } else {
          return false
        }
      },
      initMap (instance) {
        this.map = instance
        this.map.behaviors.disable('scrollZoom')
        this.mapZoomUpdate()
      },
      initLeaflet () {
        if (this.map === null) {
          // Create Leaflet map on map element.
          this.map = L.map(document.getElementById('leaflet-map'), {
            preferCanvas: true,
            center: L.latLng(51.533103, 46.034158),
            zoom: 12
          })

          // Add OSM tile layer to the Leaflet map.
          L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          }).addTo(this.map)
        } else {
          for (let i in this.layers) {
            this.map.removeLayer(this.layers[i])
          }
          this.layers = []
        }

        for (let d in this.agentList) {
          let agent = this.agentList[d]

          if (agent.coordinate === null || agent.coordinate === undefined) {
            continue
          }

          let latLng = L.latLng(agent.coordinate.lat, agent.coordinate.lng)
          let marker = L.marker(latLng, {
            icon: new L.Icon({
              iconUrl: '/static/img/maps-and-flags.svg',
              iconRetinaUrl: '/static/img/maps-and-flags.svg',
              shadowUrl: null,
              iconSize: [36, 36]
            })
          }).bindPopup(`<b><a href="/agents/single/${this.date}/${agent.user.id}">` + agent.user.first_name + ` ` + agent.user.surname + `</a></b>`).addTo(this.map)

          this.layers.push(marker)
        }

        if (this.layers.length > 0) {
          this.map.fitBounds((new L.FeatureGroup(this.layers)).getBounds())
        }
      },
      balloonTemplate (agent, date) {
        return `
            <p><img src="${agent.user.photo.url_resized}" width="50" height="50"></p>
            <p><span class="font-weight-bold">ФИО:</span> <a href="/agents/single/${date}/${agent.user.id}" style="text-decoration: none;"> ${agent.user.surname} ${agent.user.first_name} ${agent.user.patronymic} </a></p>
            <p><span class="font-weight-bold">Выручка:</span> ${agent.order_sum} ₽ / ${agent.plan_sum === 0 ? '-' : agent.plan_sum + ' ₽'} </p>
            <p><span class="font-weight-bold">Объем заказов:</span> ${agent.order_weight} кг / ${agent.plan_weight === 0 ? '-' : agent.plan_weight + ' кг'} </p>
            <p><span class="font-weight-bold">План ТТ:</span> ${agent.point_count}</p>
          `
      },
      mapZoomUpdate () {
        if (this.map !== null && this.map.geoObjects.getBounds() !== null) {
          this.map.setBounds(this.map.geoObjects.getBounds())
          if (this.map.getZoom() > 18) {
            this.map.setZoom(18)
          }
        }
      },
      updateUrl () {
        let filter = ''
        if (this.date !== null) {
          filter += '?date=' + this.date
        }

        if (this.branchId !== null) {
          if (filter === '') {
            filter += '?branch_id=' + this.branchId
          } else {
            filter += '&branch_id=' + this.branchId
          }
        }

        if (this.saleGroupId !== null) {
          if (filter === '') {
            filter += '?sale_group_id=' + this.saleGroupId
          } else {
            filter += '&sale_group_id=' + this.saleGroupId
          }
        }

        this.$router.push('/agents/activity' + filter)
      }
    },
    computed: {
      agentList () {
        return this.$store.getters.agentList
      },
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      saleGroupTitleList () {
        return this.$store.getters.saleGroupTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      saleGroupList () {
        return this.$store.getters.saleGroupList
      },
      loading () {
        return this.$store.getters.loading
      },
      totalCount () {
        return this.$store.getters.agentTotalCount
      }
    },
    created () {
      this.$store.commit('setPageLoading', true)
      this.$store.commit('setPageTitle', 'Активность агентов')
      this.$store.dispatch('getBranchList')
        .then(() => {
          this.pageDataReady.branchList = true
          this.pageDataStatus()
        })

      if (typeof this.$router.currentRoute.query.date !== 'undefined') {
        this.date = this.$router.currentRoute.query.date
      } else {
        const [day, month, year] = new Date().toLocaleDateString().split('.')
        this.date = `${year}-${month}-${day}`
      }
      if (typeof this.$router.currentRoute.query.branch_id !== 'undefined') {
        this.branchId = this.$router.currentRoute.query.branch_id
      }
      if (typeof this.$router.currentRoute.query.sale_group_id !== 'undefined') {
        this.saleGroupId = this.$router.currentRoute.query.sale_group_id
      }
    },
    watch: {
      agentList (val) {
        this.agents = this.agentList
        this.initLeaflet()
      },
      date (val) {
        this.dateFormatted = this.formatDate(this.date.replace(/\s/, 'T'))
        this.getAgentList()
      },
      branchId (val) {
        this.getAgentList()
      },
      saleGroupId (val) {
        this.getAgentList()
      },
      branchList (val) {
        if (this.$store.getters.user.branch !== null) {
          this.branch = this.$store.getters.user.branch.title
          this.branchId = this.$store.getters.user.branch.id
          this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
        }
        if (this.$store.getters.user.sale_group !== null) {
          this.saleGroup = this.$store.getters.user.sale_group.title
          this.saleGroupId = this.$store.getters.user.sale_group.id
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Agents/AgentActivity.vue